import React from 'react';

const BlogIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M0 0H14V1.64706H0V0ZM0 4.11765H8.75V5.76471H0V4.11765ZM0 8.23529H14V9.88235H0V8.23529ZM0 12.3529H8.75V14H0V12.3529Z" fill="currentColor"/>
</svg>
);

export default BlogIcon;